module.exports = __webpack_public_path__ + "img/nt112-06-85-1.prt.40031d20.jpg";